/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Canceldeal_Toast_Success2Inputs */

const en_coinvestments_canceldeal_toast_success2 = /** @type {(inputs: Coinvestments_Canceldeal_Toast_Success2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deal cancelled successfully`)
};

/**
* | output |
* | --- |
* | "Deal cancelled successfully" |
*
* @param {Coinvestments_Canceldeal_Toast_Success2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_canceldeal_toast_success2 = /** @type {((inputs?: Coinvestments_Canceldeal_Toast_Success2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Canceldeal_Toast_Success2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_canceldeal_toast_success2(inputs)
});
export { coinvestments_canceldeal_toast_success2 as "coInvestments_cancelDeal_toast_success" }